export default () => {
    let el = document.getElementById('player-component__video')
    let button = document.getElementById('player-component__button')


    if(button.style.display === 'block') {
        button.style.display = 'none'
        el.play()
        el.onended = async () => {
            button.style.display = 'block'
        }
    } else {
        button.style.display = 'block'
        el.pause()
    }
}